import React from "react"; // React
import ReactDOM from "react-dom"; // React DOM
import { BrowserRouter, Route } from "react-router-dom"; // Router
import { Provider } from "react-redux"; // Redux HOC
import ReactGA from "react-ga4"; // Google Analytics
import DeviceStateManager from "./app/device_state"; // Responsive view states (mobile, table, desktop)
import { AnalyticsLogger, CrashLogger } from "./app/logger"; // Analytics and crash loggers
import * as routes from "./constants/routes"; // Routing constants
import store from "./redux"; // Redux store
import App from "./App"; // Root component
import register from "registerServiceWorker";

// Loggers initialization
AnalyticsLogger.setUrl(window?.GeneralDeclaration?.analytics_logger_url);
CrashLogger.setUrl(window?.GeneralDeclaration?.crash_logger_url);

// Google Analytics initialization
const { REACT_APP_ANALYTICS_ID } = process.env;
REACT_APP_ANALYTICS_ID && ReactGA.initialize(REACT_APP_ANALYTICS_ID);

// Device State initialization
new DeviceStateManager(store.dispatch);



ReactDOM.render(
  <BrowserRouter basename="/">
    <Route
      path="/"
      render={({ location, history }) => {
        // Handle analytics reporting (old implementation)
        let report_location = location.pathname;
        if (location.pathname === "/") {
          report_location = routes.home;
        }

        if (typeof window.gtag === "function") {
          window.gtag("config", "AW-929315175", {
            page_path: report_location,
          });
        }

        if (typeof window.fbq === "function") {
          window.fbq("track", "PageView");
        }
        return null;
      }}
    />

    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>,
  document.getElementById("root")
);

try {
  register();
} catch (e) {
  console.error(e);
}
